module.exports = __webpack_public_path__ + "static/media/meetingRoomRed.a873a55f.png";